import React from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Paper, Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cookieAlert: {
    '& .MuiAlert-icon': {
      fontSize: 40,
      color: '#6200EE',
    },
    '& .MuiAlertTitle-root': {
      color: '#6200EE',
    },
    backgroundColor: 'white',
  },
});

const Message = ({ open, onClose, severity = 'success', title = '', message = '', autoHideDuration = 6000 }) => {
  const classes = useStyles();
  return (
    <Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
      <Paper elevation={3}>
        <Alert className={classes.cookieAlert} onClose={onClose} severity={severity}>
          <AlertTitle>{title}</AlertTitle>
          <strong>{message}</strong>
        </Alert>
      </Paper>
    </Snackbar>
  );
};

Message.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Message;
